// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontal_xYnM6 {
  width : 100%;
  display : flex;
  flex-direction : row;
  justify-content: flex-start;
  align-items : center;
  flex-wrap:wrap;
  overflow: scroll;
  max-width: 100%;
}

.vertical__Ng4k {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items : center;
}

.fill_g6Vz7 { 
  width : 100%;
}

.left_QygXH {
  align-items : flex-start;
}

.selfLeft_EoK5i {
  align-self : flex-start;
}

.name_wQ7L0 { 
  color : var( --light-grey );
  font-size : var( --font-size-base );
}

.groupHeader_JDKBb {
  width : 100%
}

.groupHeaderLine_RU0Jr {
  height: 3px ;
  width: 95%;
  /*border-radius: 1.5px;*/
  margin: 0 auto;
  background-color: var( --light-grey-50 );
}
.groupName_ZObzc {
  color : var( --pink );
  font-weight:bold;
  font-size : var( --font-size-base );
  text-transform:uppercase;
}

.rootName_HXKVH {
  font-size : var( --font-size-large );
}

.value_V_1Z0 { 
  color: var( --grey );
  font-size : var( --font-size-base );
  font-weight : bold;
  white-space : nowrap;
}

.noValue_BHw9b { 
  color: #cccccc;
  font-size : var( --font-size-base );
  font-weight : normal;
  white-space : nowrap;
}


.icon_OQafj {
  background-repeat : no-repeat;
  background-size : contain;
}
/*
.fontIcon {
  display : inline-flex;
  align-items: center;
  justify-content:center;
}

.fontIcon i{
  font-size: 24px;
}
*/
.style1_KB0ia {
  padding : 0px;
  .icon_OQafj, .fontIcon_OdqFu {
    width : 32px;
    height : 32px;
    margin-right : 5px;
  }
  
}

.group__EmIA { 
  margin : 10px;
  align-items : flex-start;
  border: 1px solid var( --light-grey-30 );
  border-radius:5px;
  padding: 0 8px;
 /* box-shadow : 0 1px 2px 0 rgba( 100, 100, 100, 0.1 ); */
}
.group__EmIA .group__EmIA {
  /*margin-left: 20px;*/ /* need this if we have no borders */
}

.card_MFmuP { 
  position: relative;
}

.editable_zVdzr:hover { 
  background-color:var( --green-10 );
}

.editIndicator_ZPHu8 {
  position : absolute;
  top : 0;
  right : 0;
  opacity : 0;
  transition : opacity 0.3s;
  color:var( --green );
}

.editable_zVdzr:hover .editIndicator_ZPHu8 {
  opacity : 1;
}

.noBorder_CK32O {
  border : none;
}

.invalid_mrQXf {
  .name_wQ7L0 {
    color : var( --red );
  }
  .value_V_1Z0 {
    color : var( --red );
  }
}

.delete_jaz53 {
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./src/views/valuecard.css"],"names":[],"mappings":"AAGA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,oBAAoB;EACpB,oBAAoB;AACtB;;;AAGA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;;;;;;;;CAUC;AACD;EACE,aAAa;EACb;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;AAEF;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,wCAAwC;EACxC,iBAAiB;EACjB,cAAc;CACf,yDAAyD;AAC1D;AACA;EACE,qBAAqB,EAAE,oCAAoC;AAC7D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@import \"../style/theme.css\";\n\n\n.horizontal {\n  width : 100%;\n  display : flex;\n  flex-direction : row;\n  justify-content: flex-start;\n  align-items : center;\n  flex-wrap:wrap;\n  overflow: scroll;\n  max-width: 100%;\n}\n\n.vertical {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items : center;\n}\n\n.fill { \n  width : 100%;\n}\n\n.left {\n  align-items : flex-start;\n}\n\n.selfLeft {\n  align-self : flex-start;\n}\n\n.name { \n  color : var( --light-grey );\n  font-size : var( --font-size-base );\n}\n\n.groupHeader {\n  width : 100%\n}\n\n.groupHeaderLine {\n  height: 3px ;\n  width: 95%;\n  /*border-radius: 1.5px;*/\n  margin: 0 auto;\n  background-color: var( --light-grey-50 );\n}\n.groupName {\n  color : var( --pink );\n  font-weight:bold;\n  font-size : var( --font-size-base );\n  text-transform:uppercase;\n}\n\n.rootName {\n  font-size : var( --font-size-large );\n}\n\n.value { \n  color: var( --grey );\n  font-size : var( --font-size-base );\n  font-weight : bold;\n  white-space : nowrap;\n}\n\n.noValue { \n  color: #cccccc;\n  font-size : var( --font-size-base );\n  font-weight : normal;\n  white-space : nowrap;\n}\n\n\n.icon {\n  background-repeat : no-repeat;\n  background-size : contain;\n}\n/*\n.fontIcon {\n  display : inline-flex;\n  align-items: center;\n  justify-content:center;\n}\n\n.fontIcon i{\n  font-size: 24px;\n}\n*/\n.style1 {\n  padding : 0px;\n  .icon, .fontIcon {\n    width : 32px;\n    height : 32px;\n    margin-right : 5px;\n  }\n  \n}\n\n.group { \n  margin : 10px;\n  align-items : flex-start;\n  border: 1px solid var( --light-grey-30 );\n  border-radius:5px;\n  padding: 0 8px;\n /* box-shadow : 0 1px 2px 0 rgba( 100, 100, 100, 0.1 ); */\n}\n.group .group {\n  /*margin-left: 20px;*/ /* need this if we have no borders */\n}\n\n.card { \n  position: relative;\n}\n\n.editable:hover { \n  background-color:var( --green-10 );\n}\n\n.editIndicator {\n  position : absolute;\n  top : 0;\n  right : 0;\n  opacity : 0;\n  transition : opacity 0.3s;\n  color:var( --green );\n}\n\n.editable:hover .editIndicator {\n  opacity : 1;\n}\n\n.noBorder {\n  border : none;\n}\n\n.invalid {\n  .name {\n    color : var( --red );\n  }\n  .value {\n    color : var( --red );\n  }\n}\n\n.delete {\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"horizontal": `horizontal_xYnM6`,
	"vertical": `vertical__Ng4k`,
	"fill": `fill_g6Vz7`,
	"left": `left_QygXH`,
	"selfLeft": `selfLeft_EoK5i`,
	"name": `name_wQ7L0`,
	"groupHeader": `groupHeader_JDKBb`,
	"groupHeaderLine": `groupHeaderLine_RU0Jr`,
	"groupName": `groupName_ZObzc`,
	"rootName": `rootName_HXKVH`,
	"value": `value_V_1Z0`,
	"noValue": `noValue_BHw9b`,
	"icon": `icon_OQafj`,
	"style1": `style1_KB0ia`,
	"fontIcon": `fontIcon_OdqFu`,
	"group": `group__EmIA`,
	"card": `card_MFmuP`,
	"editable": `editable_zVdzr`,
	"editIndicator": `editIndicator_ZPHu8`,
	"noBorder": `noBorder_CK32O`,
	"invalid": `invalid_mrQXf`,
	"delete": `delete_jaz53`
};
export default ___CSS_LOADER_EXPORT___;
